import CookiesStorageService from '../../../services/CookiesStorageService'
import SingleSectionContainer from './helpers/SingleSectionContainer'
import SingleInfo from './helpers/SingleInfo'
import SingleRole from './helpers/SingleRole'
import UseTranslation from '../../../hooks/UseTranslation'

const Index = () => {
  const { t } = UseTranslation()
  return (
  <>
    <SingleSectionContainer sectionTitle={t?.['Basic Information']}>
      <SingleInfo title={t?.['Full Name']} info={CookiesStorageService.getUserName()} />
      <SingleInfo title={t?.['Email Address']} info={CookiesStorageService.getUserEmail()} />
    </SingleSectionContainer>

    <SingleSectionContainer sectionTitle={t?.['Role Information']}>
      {CookiesStorageService.getEdsRoles()?.length > 0 &&
        <SingleRole title={`- ${t?.Eds}`} roles={CookiesStorageService.getEdsRoles()} />}
      {CookiesStorageService.getRecRoles()?.length > 0 &&
        <SingleRole title={`- ${t?.Recruitment}`} roles={CookiesStorageService.getRecRoles()} />}
      {CookiesStorageService.getSelfRoles()?.length > 0 &&
        <SingleRole title='- Self' roles={CookiesStorageService.getSelfRoles()} />}
      {CookiesStorageService.getFabsRoles()?.length > 0 &&
        <SingleRole title='- Core' roles={CookiesStorageService.getFabsRoles()} />}
    </SingleSectionContainer>
  </>
  )
}
export default Index
